
const state = {
list:[]
}

const mutations = {
//设置订单列表
SET_SETTLEMENT_LIST(state,list){
  state.list = list;
},

}

export default {
state,
mutations
}